import * as React from 'react';
import { useSelector } from 'react-redux';
import { SearchResultsLayout } from '../../components/SearchResults';
import { selectPromoIds } from '../../selectors/promos/promoIds';
import { MapEntryContainer } from '../MapEntry';
import { PromoItemContainer } from '../PromoItemContainer';
import { SearchResultsEmptyContainer } from '../SearchResultsEmptyContainer';
import { ShowButtonContainer } from '../ShowButtonContainer';

export const SearchResultsContainer: React.FC = () => {
  const promoIds = useSelector(selectPromoIds);

  if (promoIds.length) {
    return (
      <SearchResultsLayout showMoreButton={<ShowButtonContainer />}>
        {promoIds.map((promoId, index) => (
          <React.Fragment key={promoId}>
            <PromoItemContainer promoId={promoId} />
            {index === 2 && <MapEntryContainer />}
          </React.Fragment>
        ))}
      </SearchResultsLayout>
    );
  }

  return (
    <SearchResultsLayout showMoreButton={<ShowButtonContainer />} isEmptyResult>
      <SearchResultsEmptyContainer />
    </SearchResultsLayout>
  );
};
